















































import Component, { mixins } from 'vue-class-component';
import { AxiosResponse } from 'axios';
import ShowContainer from '@/common/mixin/ShowContainer';
import DetailRow from '@/common/component/DetailRow.vue';
import { CalculationRequestShowModel } from '@/context/calculation/model/CalculationRequestShowModel';
import { CalculationApi } from '@/context/calculation/api/CalculationApi';
import CalculationCard from '@/context/calculation/components/CalculationCard.vue';

@Component({
  components: {
    DetailRow,
    CalculationCard
  }
})
export default class SensorShowContainer extends mixins(ShowContainer) {
  model!: CalculationRequestShowModel;

  async fetch(id: number): Promise<void> {
    const response: AxiosResponse = await CalculationApi.instance().show(id);
    this.model = response?.data;
  }
}
